var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 34",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0736 0.557617C16.1515 0.565074 15.2312 0.907406 14.5276 1.58461V1.58461C13.105 2.9544 13.105 5.17357 14.5276 6.54312V6.54312L24.2718 15.923L26.5629 13.7176L26.6236 13.6582C28.1425 12.1336 28.1221 9.71179 26.5629 8.21072V8.21072L19.6788 1.58461L19.6172 1.52699C18.922 0.887748 18.029 0.564622 17.1333 0.557617V0.557617H17.0736ZM5.49723 10.9147L24.0391 28.803L29.1533 23.8691L10.6114 5.98082L5.49723 10.9147ZM1.64124 14.9818L1.58128 15.0406C0.9154 15.7062 0.580936 16.5626 0.578125 17.4199V17.4199V17.4421C0.58117 18.3247 0.935542 19.2062 1.64124 19.8795V19.8795C3.0592 21.2324 5.35805 21.2324 6.77531 19.8795V19.8795C8.19327 18.5267 8.19327 16.3346 6.77531 14.9818V14.9818L4.20875 12.5335L1.64124 14.9818ZM27.8743 14.6771C26.4572 16.0299 26.4572 18.222 27.8743 19.5746V19.5746L30.4418 22.0238L33.009 19.5746L33.069 19.5163C34.4261 18.1596 34.4064 16.0107 33.009 14.6771V14.6771C32.2998 14.0013 31.3707 13.6632 30.4415 13.6632V13.6632C29.5124 13.6632 28.5832 14.0013 27.8743 14.6771V14.6771ZM8.08415 21.0688L8.02208 21.13C6.50645 22.6428 6.52706 24.5185 8.08415 26.0216V26.0216L14.9765 32.7451L15.0379 32.8027C15.7375 33.4474 16.6373 33.771 17.5384 33.7737V33.7737H17.5604C18.4881 33.771 19.4147 33.4282 20.122 32.7451V32.7451C21.5433 31.374 21.5433 29.1503 20.122 27.7789V27.7789L10.3729 18.8602L8.08415 21.0688Z",
    fill: "url(#logo-linear-gradient-widget)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-linear-gradient-widget",
    x1: 24.4632,
    y1: 6.71866,
    x2: 7.54045,
    y2: 26.0372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.3fedb1e6ca1b863cc6860dc6431103ae.svg";